import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const mockData = [
  { range: '0-30 days', accounts: 423, value: 3200000 },
  { range: '31-60 days', accounts: 356, value: 2800000 },
  { range: '61-90 days', accounts: 289, value: 2300000 },
  { range: '91-180 days', accounts: 234, value: 1900000 },
  { range: '181-365 days', accounts: 167, value: 1400000 },
  { range: '365+ days', accounts: 98, value: 800000 },
];

export function AccountAgingChart() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Account Aging</CardTitle>
        <CardDescription>Distribution by delinquency period</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={mockData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="range" 
              className="text-xs"
              stroke="hsl(var(--muted-foreground))"
              angle={-45}
              textAnchor="end"
              height={80}
            />
            <YAxis 
              yAxisId="left"
              className="text-xs"
              stroke="hsl(var(--muted-foreground))"
            />
            <YAxis 
              yAxisId="right"
              orientation="right"
              className="text-xs"
              stroke="hsl(var(--muted-foreground))"
              tickFormatter={(value) => `R${(value / 1000000).toFixed(1)}M`}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
              formatter={(value: number, name: string) => {
                if (name === 'value') return `R${(value / 1000000).toFixed(2)}M`;
                return value;
              }}
            />
            <Legend />
            <Bar 
              yAxisId="left"
              dataKey="accounts" 
              fill="hsl(var(--chart-1))" 
              name="Account Count"
              radius={[4, 4, 0, 0]}
            />
            <Bar 
              yAxisId="right"
              dataKey="value" 
              fill="hsl(var(--primary))" 
              name="Total Value"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
